export default function environmentVariableReducer(state = {
    environmentVariableValue: []
  }, action) {
    switch (action.type) {
      case 'GET_ENVIRONMENT_VARIABLE_PENDING': {
        return {
          ...state
        }
      }
      case 'GET_ENVIRONMENT_VARIABLE_FULFILLED': {
        return {
          ...state,
          environmentVariableValue: action.payload
        }
      }
      case 'GET_ENVIRONMENT_VARIABLE_REJECTED': {
        return {
          ...state,
          errors: action.payload.errors
        }
      }
      default:
    }
  
    return {...state};
  }


// WEBPACK FOOTER //
// ./src/reducers/environmentVariableReducer.js